import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonHeader,
} from "@ionic/react";
import React from "react";
import { useHistory } from "react-router-dom";
import TopLeftUserName from "../components/TopLeftUserName";
function VisitSummary() {
  let history = useHistory();
  return (
    <>
      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <TopLeftUserName headerText={"Search"}></TopLeftUserName>
          <IonGrid
            className="container create-patient-pages"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="top-inner-sec">
                  <div className="left-arrow">
                    <svg
                      onClick={() => {
                        history.goBack();
                      }}
                      className="svg-icons"
                      width="16"
                      height="26"
                      viewBox="0 0 16 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                        fill="#31344E"
                        stroke="black"
                      />
                    </svg>
                  </div>
                  <h1>James Baker</h1>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonHeader>
        <IonContent placeholder={undefined} className="slide-in-right">
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="visit-summary-inner-sec">
                  <h3>Visit Summary</h3>
                  <h4>Friday - Feb 4, 2022</h4>
                  <div className="visit-summary-inner-detail">
                    <p>Visit summary info will go here.</p>
                  </div>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    </>
  );
}
export default VisitSummary;
